import { render, staticRenderFns } from "./RestoreBackupButton.vue?vue&type=template&id=6df59cf8&scoped=true&"
import script from "./RestoreBackupButton.vue?vue&type=script&lang=ts&"
export * from "./RestoreBackupButton.vue?vue&type=script&lang=ts&"
import style0 from "./RestoreBackupButton.vue?vue&type=style&index=0&id=6df59cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df59cf8",
  null
  
)

export default component.exports